import * as firebase from 'firebase'
import { getModule, Action, Module, Mutation, VuexModule } from 'vuex-module-decorators'

import { auth } from '@/datastore'
import store from '@/store'

@Module({ dynamic: true, name: 'auth', namespaced: true, store })
class AuthModule extends VuexModule {

	initialized = false

	user: firebase.UserInfo | null = null

	get isLoggedIn() {
		return !!this.user
	}

	@Mutation
	setInitialized() {
		this.initialized = true
	}

	@Mutation
	setUser(user: firebase.UserInfo | null) {
		this.user = user
	}

	@Action
	async initialize() {

		if (this.initialized) {
			return
		}

		return new Promise<void>(resolve => {

			auth.onAuthStateChanged(async user => {
				const { uid: oldUid } = this.user || { uid: null  }
				const { uid: newUid } = user || { uid: null }

				if (newUid !== oldUid) {
					if (user) {
						this.setUser(user.toJSON() as firebase.UserInfo)
					}
					else {
						this.setUser(null)
					}
				}

				resolve()
			})

			this.setInitialized()
		})
	}

}

export default getModule(AuthModule)
